import {Component, Inject, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Employee} from '../../admin/models/employee.model';
import {VacationTrackerUser} from '../../core/user/vacation-tracker-user';
import {FormControl, NgForm} from '@angular/forms';
import {HrService} from '../hr.service';
import {UserService} from '../../core/user/user.service';
import {FabMessageService} from '@fabric/components/message';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {FabThemeService} from '@fabric/components/theme';
import {AuthenticationService} from '../../core/authentication/authentication.service';
import {PersonalService} from '../../personal/personal.service';
import {Team} from '../../admin/models/team.model';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-edit-employee-pop-up',
    templateUrl: './edit-employee-pop-up.component.html',
    styleUrls: ['./edit-employee-pop-up.component.scss']
})
export class EditEmployeePopUpComponent implements OnInit {

    public employee = {} as Employee;
    public teamData: Team[] = [];
    public user = {} as VacationTrackerUser;
    public isPageLoading = false;
    public contractTypes = [
        {value: 'FULL_TIME_PERMANENT', displayValue: 'Full Time Permanent'},
        {value: 'INTERN', displayValue: 'Intern'},
        {value: 'FIXED_TERM', displayValue: 'Fixed Term'}];
    public roles = [
        {value: 'ABT_HR', displayValue: 'HR'},
        {value: 'ABT_MANAGER', displayValue: 'Manager'},
        {value: 'ABT_EMPLOYEE', displayValue: 'Employee'}];
    public role = {} as any;
    public date = new FormControl(new Date());
    public employeeName = '';

    @ViewChild('form') private readonly form!: NgForm;
    @ViewChild('deleteModal') deleteModal!: TemplateRef<any>;

    constructor(private readonly hrService: HrService,
                private readonly userService: UserService,
                private readonly messageService: FabMessageService,
                private readonly personalService: PersonalService,
                private readonly authService: AuthenticationService,
                public readonly themeService: FabThemeService,
                public readonly dialog: MatDialog,
                public dialogRef: MatDialogRef<[]>,
                @Inject(MAT_DIALOG_DATA) public selectedData: any) {
    }


    ngOnInit(): void {
        this.personalService.fetchEmployeeByGmin(this.selectedData.employeeGmin).subscribe({
            next: (data) => {
                this.employee = data;
                this.employee.updatedBy = this.authService.userInfo.gmin || '';
                this.teamData = this.selectedData.teamData;
                this.date.patchValue(new Date(this.personalService.swapDateAndMonth(this.employee.dateStarted)));
                this.user.roles = [this.roles[2].value];
                this.isPageLoading = false;
            },
            error: () => this.messageService.displayErrorMessage('Error fetching data')
        });
        this.isPageLoading = true;
    }

    /**
     * Sets the employee dateStarted from the formControl object
     */
    public setModelDate() {
        this.employee.dateStarted = this.date.value!.toString();
        this.employee.dateStarted = this.hrService.convertDateFormatForAPI(this.employee.dateStarted);
    }

    /**
     * Closes the popup
     */
    close(): void {
        this.dialogRef.close();
        this.dialog.closeAll();
    }

    /**
     * delete an employee
     */
    deleteEmployee() {
        this.hrService.deleteEmployee(this.employee.id).subscribe({
            next: () => {
                this.isPageLoading = false;
                this.messageService.displayMessage('Employee has been deleted');
                this.close();
            }, error: (err: HttpErrorResponse) => {
                this.isPageLoading = false;
                this.messageService.displayErrorMessage(err.error.errorMessage);
                this.close();
            }
        });
    }

    /**
     * Opens the pop-up modal.
     * Retrieves the countryCode from local storage.
     * Sets the width and height of the modal.
     */
    public openModal(): void {
        this.employeeName = `${this.employee.firstName} ${this.employee.lastName}`
        let multiplyValue = 0.4;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = true;
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        if (window.innerHeight > 700) {
            multiplyValue = 0.3;
            dialogConfig.maxHeight = window.innerHeight * multiplyValue;
            dialogConfig.minHeight = window.innerHeight * multiplyValue;
            dialogConfig.minWidth = window.innerWidth * 0.05;

        } else {
            dialogConfig.maxHeight = window.innerHeight * multiplyValue;
            dialogConfig.minHeight = window.innerHeight * multiplyValue;
            dialogConfig.minWidth = window.innerWidth * 0.05;
        }

        this.dialog.open(this.deleteModal, dialogConfig);
    }

    /**
     * Submits the form to create a new employee.
     * Uses people search to find an employee and populate the form.
     */
    submitForm(): void {
        this.setModelDate();
        this.role = this.user.roles;
        this.hrService.updateEmployee(this.employee, this.role).subscribe({
            next: () => {
                this.messageService.displayMessage('Request submitted successfully');
                this.close();
            }, error: () => {
                this.messageService.displayErrorMessage('Request submission failed');
            }
        });
    }
}
